import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatMrn",
})
export class FormatMrnPipe implements PipeTransform {
  transform(mrn: string | null): string {
    if (!mrn) return "--";

    const mrnSplitArray = mrn.split(/\d*\-0*/);
    return mrnSplitArray.length > 1 ? mrnSplitArray[1] : "--";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/format-mrn.pipe.ts